import { HEADER_ACTIONS } from "./Header.actions";

export const HeaderReducer = (state, action) => {
  switch (action.type) {
    case HEADER_ACTIONS.LOADING:
      return {
        ...state,
        loading: action.payload,
        success: null,
        error: null
      };
    case HEADER_ACTIONS.ERROR:
      return {
        ...state,
        error: action.payload,
        success: null,
        loading: false,
      };
    case HEADER_ACTIONS.SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        success: action.payload,
      };
    case HEADER_ACTIONS.RESET:
      return{
        ...state,
        error: null,
        loading: false,
        success: null,
      }
    default:
      return { ...state };
  }
};
